/**
 * 红娘返现表请求接口
 * @author 王振宇
 * @since 2022-11-14
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MATCHMAKERCASHBACK_PAGE_LIST: function GET_MATCHMAKERCASHBACK_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerCashBack/getPageList',
        method: 'post',
        data: data
      });
    },
    GET_MATCHMAKERCASHBACK_LIST: function GET_MATCHMAKERCASHBACK_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerCashBack/getList',
        method: 'get',
        params: data
      });
    },
    GET_MATCHMAKERCASHBACK_INFO: function GET_MATCHMAKERCASHBACK_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerCashBack/info',
        method: 'get',
        params: data
      });
    },
    SAVE_MATCHMAKERCASHBACK: function SAVE_MATCHMAKERCASHBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerCashBack/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MATCHMAKERCASHBACK: function UPDATE_MATCHMAKERCASHBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerCashBack/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MATCHMAKERCASHBACK: function DELETE_MATCHMAKERCASHBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerCashBack/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MATCHMAKERCASHBACK: function DELETE_BATCH_MATCHMAKERCASHBACK() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/matchmakerCashBack/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});